<template>
  <div>
    <!-- Search + FAB -->
    <v-row class="pa-3" align="center">
      <v-col>
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Cerca cliente..."
          dense
          outlined
          hide-details
          clearable
        />
      </v-col>
    </v-row>

    <v-tabs v-model="tab" background-color="transparent" grow class="px-3">
      <v-tab>Attive ({{ prenotazioni_attive.length }})</v-tab>
      <v-tab>Archivio</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Attive -->
      <v-tab-item>
        <v-list two-line>
          <template v-if="attive_filtrate.length">
            <v-list-item
              v-for="p in attive_filtrate"
              :key="p._id.$oid"
              @click="apri_dettaglio(p)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ p.cliente }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ p.data }} · {{ p.articoli.length }} articoli
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <StatoBadge :stato="p.stato" />
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item v-else>
            <v-list-item-content class="grey--text text-center">
              Nessuna prenotazione attiva
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-tab-item>

      <!-- Archivio -->
      <v-tab-item>
        <v-list two-line>
          <template v-if="archivio_filtrato.length">
            <v-list-item
              v-for="p in archivio_filtrato"
              :key="p._id.$oid"
              @click="apri_dettaglio(p)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ p.cliente }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ p.data }} · {{ p.articoli.length }} articoli
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <StatoBadge :stato="p.stato" />
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item v-else>
            <v-list-item-content class="grey--text text-center">
              {{ archivio_loaded ? "Nessuna prenotazione in archivio" : "Caricamento..." }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-tab-item>
    </v-tabs-items>

    <!-- FAB nuova prenotazione -->
    <NuovaPrenotazioneDialog @creata="apri_dettaglio">
      <template #activator="{ on }">
        <v-btn fab fixed bottom right color="primary" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </NuovaPrenotazioneDialog>

    <!-- Dettaglio (riutilizza lo stesso fullscreen dialog del desktop) -->
    <PrenotazioneDettaglio
      v-if="prenotazione_aperta"
      v-model="dialog_dettaglio"
      :prenotazione="prenotazione_aperta"
      @input="on_chiudi_dettaglio"
    />
  </div>
</template>

<script>
import mixin from "@/components/Prenotazioni/mixin/prenotazioni_mixin.js";
import StatoBadge from "@/components/Prenotazioni/common/StatoBadge.vue";
import NuovaPrenotazioneDialog from "@/components/Prenotazioni/desktop/NuovaPrenotazioneDialog.vue";
import PrenotazioneDettaglio from "@/components/Prenotazioni/desktop/PrenotazioneDettaglio.vue";

export default {
  name: "PrenotazioniMobile",

  components: { StatoBadge, NuovaPrenotazioneDialog, PrenotazioneDettaglio },

  mixins: [mixin],

  data() {
    return {
      dialog_dettaglio: false,
      prenotazione_aperta: null,
    };
  },

  methods: {
    apri_dettaglio(prenotazione) {
      this.prenotazione_aperta = prenotazione;
      this.dialog_dettaglio = true;
    },

    on_chiudi_dettaglio(val) {
      if (!val) {
        this.dialog_dettaglio = false;
        this.prenotazione_aperta = null;
      }
    },
  },
};
</script>
